import { Flex, Text } from "@radix-ui/themes";
import { useSearchParams } from "react-router-dom";
import { useAuth } from "../../../contexts/AuthContext";
import LoadingIndicator from "../../shared/LoadingIndicator";
import DesktopAuthFlow from "./DesktopAuthFlow";

interface Props {
    sessionId?: string;
}

export default function McpConnectorFlow({ sessionId: propSessionId }: Props) {
    const [searchParams] = useSearchParams();
    const { user, loading } = useAuth();

    // Resolve session ID from props or URL
    const sessionId = propSessionId || searchParams.get("session_id");
    const isDesktop = searchParams.get("is_desktop") === "true";

    // Wait for session check
    if (loading) {
        return (
            <Flex
                align="center"
                justify="center"
                style={{
                    height: "100vh",
                }}
                direction="column"
                gap="4"
            >
                <LoadingIndicator />
                <Text>Verifying session...</Text>
            </Flex>
        );
    }

    // 1. Desktop Flow: Delegate to DesktopAuthFlow
    if (isDesktop && sessionId) {
        return <DesktopAuthFlow sessionId={sessionId} user={user} loading={loading} />;
    }

    // 2. MCP Connector Flow: Redirect to Add Device Page
    if (user && sessionId && !isDesktop) {
        console.log("🔌 [AUTH] MCP Connector Flow - Redirecting to Add Device");
        const mcpUrl = import.meta.env.VITE_MCP_URL || window.location.origin;
        // Carry the assistant through so the setup screen can name it and show one help link.
        const client = searchParams.get("client");
        const params = new URLSearchParams({
            session_id: sessionId,
        });
        if (client) {
            params.set("client", client);
        }
        window.location.href = `${mcpUrl}/add-device?${params.toString()}`;

        return (
            <Flex
                align="center"
                justify="center"
                style={{
                    height: "100vh",
                }}
                direction="column"
                gap="4"
            >
                <LoadingIndicator />
                <Text>Redirecting to application...</Text>
            </Flex>
        );
    }

    // Fallback / Error view
    return (
        <Flex
            align="center"
            justify="center"
            style={{
                height: "100vh",
            }}
            direction="column"
            gap="4"
        >
            <LoadingIndicator />
            <Text>Completing authorization...</Text>
        </Flex>
    );
}
